import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useVendorStore from "../../../AuthStore/store/authStore";
import showLoginToast from "../../CustomHotToast/CustomToast";

const BrokerSignupForm = ({ onSuccess }) => {
  const { signUpAsvendor } = useVendorStore();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    referel_id: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrorMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await signUpAsvendor(formData);
      console.log("Broker signup successful:", response);

      showLoginToast.success(response.message+"Waiting for admin Aproved When Admin Approve your id is send to " || "Signup successful!");
      onSuccess();
      navigate("/log-in");
    } catch (error) {
      console.error("Signup vendor from error:", error);
      setErrorMsg(  "Signup failed. Please try again.");
     const errors = error?.response?.data?.errors;

      if (errors && Object.keys(errors).length > 0) {
        const firstErrorKey = Object.keys(errors)[0];
        setErrorMsg(errors[firstErrorKey][0]);

        showLoginToast.error(errors[firstErrorKey][0]);
        return;
      }


      showLoginToast.error(" email or Phone number Already used!");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-lg font-bold mb-4 text-center text-indigo-700">
        Broker Signup
      </h2>

      <div className="grid grid-cols-2 gap-4">
        <input
          name="firstName"
          placeholder="First Name"
          value={formData.firstName}
          onChange={handleChange}
          className="w-full border rounded px-3 py-2"
        />
        <input
          name="lastName"
          placeholder="Last Name"
          value={formData.lastName}
          onChange={handleChange}
          className="w-full border rounded px-3 py-2"
        />
      </div>
      <input
        name="email"
        placeholder="Email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />
      <input
        name="phone"
        placeholder="Phone"
        type="tel"
        value={formData.phone}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />
      <input
        name="password"
        placeholder="Password"
        type="password"
        value={formData.password}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />
      <input
        name="confirmPassword"
        placeholder="Confirm Password"
        type="password"
        value={formData.confirmPassword}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />
      <input
        name="referel_id"
        placeholder="Referel ID"
        value={formData.referel_id}
        onChange={handleChange}
        className="w-full border rounded px-3 py-2"
      />

      {errorMsg && <p className="text-red-500 text-sm">{errorMsg}</p>}

      <button
        type="submit"
        className="w-full py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Creating Account..." : "Create Account"}
      </button>
    </form>
  );
};


export default BrokerSignupForm;